import "./Home.module.css";
import FraternalExcellenceHeader from "@/reusable_sections/Header";
import ThePulseOfProgress from "./sections/ThePulseOfProgress";
import SpaceOpportunities from "./sections/SpaceOpportunities";
import FromPrepToPublish from "./sections/FromPrepToPublish";
import TheTransformationGallery from "./sections/TheTransformationGallery";
import VoicesOfSecurity from "./sections/VoicesOfSecurity";
import BeginYourTransformation from "./sections/BeginYourTransformation";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <FraternalExcellenceHeader />
      <ThePulseOfProgress />
      <SpaceOpportunities />
      <FromPrepToPublish />
      <TheTransformationGallery />
      <VoicesOfSecurity />
      <BeginYourTransformation />
      <Footer />
    </div>;
}